// Report package limits shared by the widget and the service (quint/contracts/report_package.qnt, Rp1, Rp6).

/** The service refuses a longer description. */
export const MAX_DESCRIPTION = 20_000;

const ELLIPSIS = '…';
// A cut looks for a line or word break this close to the ceiling before it falls back to a hard cut.
const BREAK_WINDOW = 400;

/** Rp6: the window fits the description into the service ceiling; the full texts stay in the scenarios of the snapshot. */
export function fitDescription(text: string): string {
  if (text.length <= MAX_DESCRIPTION) return text;
  const limit = MAX_DESCRIPTION - ELLIPSIS.length;
  const head = text.slice(0, limit);
  const at = Math.max(head.lastIndexOf('\n'), head.lastIndexOf(' '));
  const cut = at >= limit - BREAK_WINDOW ? head.slice(0, at) : head;
  return `${cut.trimEnd()}${ELLIPSIS}`;
}
